// This is Net, MFWNet, IAMnet etc... 
export const useShouldShowPublic = ({
  option,
  isNutrition,
}: {
  option: boolean;
  isNutrition: boolean;
}): boolean => {
  // BEFORE
  //  entityName !== "Grocery" && entityName !== "Meal" && entityName !== "NutritionPlan" &&
  // options?.showPublic !== false &&
  // (!isWhiteLabel || (isWhiteLabel && organizationId === mfwTheme.theme.orgId)) ???
  
  const contentPermission:boolean = !isNutrition;
  const orgPermission:boolean = true;
  const res: boolean = option && contentPermission && orgPermission;

  return res;
};
